angular.module('dnecom')
    .controller('EmailTemplateController', ["$scope", "$rootScope", "$http", "notifications", "$timeout", "Upload", function ($scope, $rootScope, $http, notifications, $timeout, Upload) {
        $scope.currentStore = TemplateData.value('store');
        $scope.storeLogo = (TemplateData.value('storeLogo') || '').replace(/"/g, ''); // empty string is passed as '""' O_O

        try {
            $scope.settings = TemplateData.value('settings');
            $scope.defaultLogo = $scope.settings.logo || '';
        } catch (e) {
            $scope.settings = {};
            $scope.defaultLogo = '';
        }

        $scope.init = function(template, defaultTemplate) {
            if (!defaultTemplate) {
                defaultTemplate = {};
            }

            if (template.default && $scope.settings) {
                template.allowStoreLogo = $scope.settings.allowStoreLogo;
            }

            $scope.defaultTemplate = defaultTemplate;
            $scope.originalTemplate = angular.copy(template);
            $scope.template = angular.copy(template);

            $scope.defaultTemplate.id = $scope.template.id;
            $scope.defaultTemplate.updatedAt = $scope.template.updatedAt;
        };

        $scope.getPreviewUrl = function() {
            return Routing.generate('notifications_preview', {
                id: $scope.currentStore.id,
                logoUrl: $scope.template.logo ? $scope.template.logo.imgixName : null,
                allowStoreLogo: $scope.template.allowStoreLogo ? 1 : 0,
                type: $scope.template.type,
                logoWidth: $scope.template.logoWidth,
                linkColor: $scope.template.linkColor,
                buttonColor: $scope.template.buttonColor,
                headlineFont: $scope.template.headlineFont,
                textFont: $scope.template.textFont
            });
        };

        $scope.upload = function(file) {
            if (!file) {
                return;
            }

            Upload.upload({
                url: Routing.generate('upload_file', {store: $scope.currentStore.id}),
                data: {
                    file: file
                }
            }).then(function(response) {
                if (response.data.success) {
                    $scope.template.logo = response.data.media;
                } else {
                    notifications.danger(response.data.message);
                }
            }, function() {
                notifications.danger('There was a problem with image uploading.');
            });
        };

        $scope.uploadUrl = function(url) {
            if (!url) {
                return;
            }

            $http
                .post(Routing.generate('upload_file', {store: $scope.currentStore.id}), {
                    image: url
                })
                .then(function(response) {
                    if (response.data.success) {
                        $scope.template.logo = response.data.media;
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function() {
                    notifications.danger('There was a problem with image uploading.');
                });
        };

        $scope.useDefaultLogo = function() {
            $scope.template.logo = null;
            $scope.template.allowStoreLogo = true;
        };

        $scope.removeLogo = function() {
            $scope.template.logo = null;
            $scope.template.allowStoreLogo = false;
        };

        $scope.resetTemplate = function() {
            $scope.template = angular.extend({}, $scope.template, $scope.defaultTemplate);

            $rootScope.$broadcast('template.edit.done', $scope.template);
        };

        $scope.isResetDisabled = function() {
            return angular.equals($scope.template, $scope.defaultTemplate);
        };

        $scope.saveTemplate = function () {
            if (angular.equals($scope.template, $scope.originalTemplate)) {
                $rootScope.$broadcast('template.edit.done');
                return;
            }

            $scope.template.logo = $scope.template.logo || null;

            $http.put(
                    Routing.generate('notifications_update', {
                        id: $scope.currentStore.id,
                        templateId: $scope.template.id || 0
                    }),
                    $scope.template
                )
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    notifications.success('Template saved.');

                    $timeout(function () {
                        $scope.template.id = response.data.id;
                    });
                }, function () {
                    notifications.danger('Request error.');
                })
                .finally(function () {
                    $rootScope.$broadcast('template.edit.done', $scope.template);
                })
            ;
        };
    }]);
